<template>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >
    <v-checkbox
      v-model='value.isDefault'
      :label='`use default bot name format`'
      color='orange'
      @change="checkDefault($event, index)">
    </v-checkbox>

    <v-checkbox
      v-model='value.isAddReport'
      :label='`create report`'
      color='orange'>
    </v-checkbox>

    <v-flex xs12>
      <v-select
        v-model='value.type'
        prepend-icon='mdi-file-document-box'
        label='Account Type'
        class='input-data'
        required
        :items='accountType'
      ></v-select>
    </v-flex>

    <v-flex xs12>
      <v-text-field
        v-model='value.base'
        label='Base'
        prepend-icon='mdi-currency-usd'
        class='input-data'
        required
        clearable
        :rules="[v => !!(v || '').trim() || 'Required']"
      ></v-text-field>
    </v-flex>

    <v-flex xs12>
      <v-text-field
        v-model='value.quote'
        label='Quote'
        prepend-icon='mdi-currency-usd'
        class='input-data'
        required
        clearable
        :rules="[v => !!(v || '').trim() || 'Required']"
      ></v-text-field>
    </v-flex>

    <v-flex xs12>
      <v-text-field
        v-model='value.xaccount'
        label='Exchange Account Name'
        prepend-icon='mdi-account-box-outline'
        class='input-data'
        required
        clearable
        :rules="[v => !!(v || '').trim() || 'Required']"
      ></v-text-field>
    </v-flex>

     <v-flex xs12>
      <v-text-field
        v-model='value.exchange_username'
        label='Exchange Username (dev@yellow.com)'
        prepend-icon='mdi-account'
        class='input-data'
        clearable
        :rules="[v => !!(v || '').trim()]"
      ></v-text-field>
    </v-flex>

    <v-flex xs12>
      <v-text-field
        v-model='value.name'
        label='Bot Name (account id)'
        prepend-icon='mdi-gamepad-variant'
        class='input-data'
        filled
        clearable
        required
        :rules="[v => !!(v || '').trim() || 'Required']"
      >{{ botName(index) }}</v-text-field>
    </v-flex>

    <v-flex xs12 v-if="value.isAddReport">
      <v-text-field
        v-model='value.reportName'
        label='Report Name'
        prepend-icon='mdi-file-excel'
        class='input-data'
        filled
        clearable
        :rules="[v => !!(v || '').trim()]"
      >{{ reportName(index) }}</v-text-field>
    </v-flex>
    <div class='spacer'></div>
    <!-- keys section -->
    <v-expansion-panel ref="panels" expand v-model='panel'>
      <SubAccountInfo v-model='value.subaccount' />
      <KeyInfo v-model='value.api.full' type='Full' />
      <KeyInfo v-model='value.api.readonly' type='Readonly' />
      <KeyInfo v-model='value.api.report' type='Report'  v-if="value.isAddReport"/>
    </v-expansion-panel>
    <!-- End keys section -->
    <v-alert
      :value="errorMessage"
      type="error"
    >
      {{errorMessage}}
    </v-alert>
    <v-flex xs12>
      <v-btn
      color='green'
      @click="save"
      style='color: white !important;margin-top: 20px'
      :loading="loading">
        Save
      </v-btn>
    </v-flex>
   
  </v-form>
</template>

<script>
import MongoService from '../../services/mongo.service'
import KeyInfo from './KeyInfo';
import SubAccountInfo from './SubAccountInfo';

export default {
  props: {
    value: { type: Object, require: true },
    index: { type: Number, require: true },
    basic: { type: Object, require: true }
  },
  data() {
    return {
      accountType: ['main_buffer', 'client_buffer', 'bot', 'tpw', 'report'],
      errorMessage: '',
      valid: true,
      loading: false,
      panel: [true, true, false, false]
    };
  },
  components: {
    KeyInfo,
    SubAccountInfo
  },
  methods: {
  botName(index, isDefault = true) {
      const pair = this.value
      if (pair.isDefault) {
        const base = pair.base ? pair.base.toLowerCase() : ''
        const quote = pair.quote ? pair.quote.toLowerCase() : ''
        const xaccount = pair.xaccount ? pair.xaccount.toLowerCase() : ''
        const exchangeName = this.basic.exchange && this.basic.exchange !== '' ? this.basic.exchange.toLowerCase() : ''
        const name = `mm_${exchangeName}_${base}${quote}_${xaccount}`;
        pair.name = name;
      }
    },
    reportName(index) {
      const pair = this.value
      if (pair.isDefault) {
        const xaccount = pair.xaccount ? pair.xaccount.toLowerCase() : ''
        const exchangeName =  this.basic.exchange && this.basic.exchange !== '' ? this.basic.exchange.toLowerCase() : ''
        const reportName = `report_${exchangeName}_${xaccount}`;
        pair.reportName = reportName;
      }
    },
    checkDefault(isCheck, index) {
      this.botName(index, isCheck)
      this.reportName(index, isCheck)
    },
    async save() {
      if (!this.$refs.form.validate()) {
        if (!this.value.api.full.key || !this.value.api.full.secret) this.panel[1] = true
        if (!this.value.api.readonly.key || !this.value.api.readonly.secret) this.panel[2] = true
        if (!this.value.api.report.key || !this.value.api.report.secret) this.panel[3] = true
        const panels = this.$refs['panels'];
        panels.updateFromValue(this.panel);
        return
      }
      if (!this.basic.exchange || !this.basic.client ) {
        this.errorMessage = `Client Name and Exchange are required`
        return
      }

      this.loading = true

      this.result = null
      try {
        this.result = await MongoService.accountConfig.insert({ pair: this.value, basic: this.basic })
      } catch (e) {
        this.errorMessage = e.message
      }
      this.loading = false
    }
  }
};
</script>